module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_0.95c3e6b9.png";